import { Component, Input, OnInit, OnDestroy, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FileViewExplorerComponent } from 'src/app/file-view-explorer/file-view-explorer.component';
import { CommonService } from 'src/app/services/common.service';
import { TabChangeService } from 'src/app/services/tab-change.service';
import { ModalTabVisibilityService } from '../../services/modal-tab-visibility.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-caseinfo',
  templateUrl: './caseinfo.component.html',
  styleUrls: ['./caseinfo.component.scss']
})
export class CaseinfoComponent implements OnInit, OnDestroy  {
  caseInfoDetails:object = {};
  patienInfo:object = {};
  OrderDetails:object = {};
  islabadmin:boolean = false;
//@Input() caseInfoData={}

selectedIndexTab = 0;

  // Modal tab management
  private destroy$ = new Subject<void>();
  private tabChangeSubscription: Subscription;
  private componentName = 'case 360 prime';
  private isActiveTab = true;
  private modalWasOpen = false;
  private currentModalRefs: any[] = [];

  constructor(
    private service: CommonService,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder,
    private ngxUiLoaderService: NgxUiLoaderService,
    private modalService: NgbModal,
    @Inject('caseData') public caseInfoData: any,
    private tabChangeService: TabChangeService,
    private modalTabVisibility: ModalTabVisibilityService
  ) {

   }

   ngOnInit(){
    // Subscribe to tab changes
    this.tabChangeSubscription = this.tabChangeService.tabChange$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((tabName: string) => {
      this.isActiveTab = tabName.toLowerCase() === this.componentName.toLowerCase();
      setTimeout(() => {
        if (this.isActiveTab) {
          this.modalTabVisibility.hideForeignOwnedModals('data-case360-modal');
          this.showModals();
        } else {
          this.hideModals();
        }
      }, 0);
    });
    
    if(this.caseInfoData !== undefined){
    this.islabadmin=this.caseInfoData['islabadmin'] ;
    this.caseInfoDetails = this.caseInfoData['Case'];
    // console.log(this.caseInfoDetails)
    this.patienInfo = this.caseInfoData['Case'].Patient
    this.OrderDetails = this.caseInfoData['Case'].OrderDetails
    if(this.caseInfoDetails['QualityAttributesDetails'] !== undefined?this.caseInfoDetails['QualityAttributesDetails'].QualityAttribute:false){
      let attribute = this.caseInfoDetails['QualityAttributesDetails'].QualityAttribute.filter(va =>va.Category !=="Flags")
      this.caseInfoDetails['QualityAttributesList']=attribute
      let flags = this.caseInfoDetails['QualityAttributesDetails'].QualityAttribute.filter(va =>va.Category ==="Flags")
      this.caseInfoDetails['Flags']=flags
    }
    if(this.caseInfoDetails['ServiceProvider'] !== undefined?this.caseInfoDetails['ServiceProvider']:false){

      if(Array.isArray(this.caseInfoDetails['ServiceProvider'])){
        let labs= this.caseInfoDetails['ServiceProvider'].filter(va =>va.Location.AccountType=== "Laboratory")
        if(labs.length>0){
          labs.length>0?this.caseInfoDetails['laboratory'] = labs[0].Location:this.caseInfoDetails['laboratory']=''
         }
         let sendout = this.caseInfoDetails['ServiceProvider'].filter(va =>va.Location.AccountType === "Send-out Laboratory")
         sendout.length>0?  this.caseInfoDetails['sendOut'] = sendout[0].Location:  this.caseInfoDetails['sendOut']=''
         let sendin = this.caseInfoDetails['ServiceProvider'].filter(va =>va.Location.AccountType === "Send-in Laboratory" ||va.Location.AccountType=== "Send In Lab")
         sendin.length>0?  this.caseInfoDetails['sendIn'] = sendin[0].Location:  this.caseInfoDetails['sendIn']=''
      }else{
        if(this.caseInfoDetails['ServiceProvider'].Location.AccountType !== undefined && this.caseInfoDetails['ServiceProvider'].Location.AccountType === "Laboratory" ){
          this.caseInfoDetails['laboratory'] = this.caseInfoDetails['ServiceProvider'].Location
        }else{
          this.caseInfoDetails['laboratory'] ='';
        }
        if(this.caseInfoDetails['ServiceProvider'].Location.AccountType !== undefined && this.caseInfoDetails['ServiceProvider'].Location.AccountType === "Send-out Laboratory" ){
          this.caseInfoDetails['sendOut'] = this.caseInfoDetails['ServiceProvider'].Location
        }else{
          this.caseInfoDetails['sendOut'] ='';
        }
        if(this.caseInfoDetails['ServiceProvider'].Location.AccountType !== undefined && this.caseInfoDetails['ServiceProvider'].Location.AccountType === "Send-in Laboratory" ){
          this.caseInfoDetails['sendIn'] = this.caseInfoDetails['ServiceProvider'].Location
        }else{
          this.caseInfoDetails['sendIn'] ='';
        }
      }
    }
    //  if(this.caseInfoDetails['ServiceProvider'].Location.AccountType !== undefined && this.caseInfoDetails['ServiceProvider'].Location.AccountType !== undefined){
    //     this.caseInfoDetails['laboratory'] = this.caseInfoDetails['ServiceProvider'].Location
    //    }else if(this.caseInfoDetails['ServiceProvider'].length>0){
    //     let labs= this.caseInfoDetails['ServiceProvider'].filter(va =>va.Location.AccountType=== "Laboratory")
    //     if(labs.length>0){
    //       labs.length>0?this.caseInfoDetails['laboratory'] = labs[0].Location:this.caseInfoDetails['laboratory']=''
    //      }
    //      let sendout = this.caseInfoDetails['ServiceProvider'].filter(va =>va.Location.AccountType === "Send-out Laboratory")
    //      sendout.length>0?  this.caseInfoDetails['sendOut'] = sendout[0].Location:  this.caseInfoDetails['sendOut']=''
    //      let sendin = this.caseInfoDetails['ServiceProvider'].filter(va =>va.Location.AccountType === "Send-in Laboratory" ||va.Location.AccountType=== "Send In Lab")
    //      sendin.length>0?  this.caseInfoDetails['sendIn'] = sendin[0].Location:  this.caseInfoDetails['sendIn']=''
    //    }
    //   }

      if(this.caseInfoDetails['OrderDetails']!== undefined?this.caseInfoDetails['OrderDetails'].Order.ICDCodes !=='':false){
        this.caseInfoDetails['OrderDetails'].Order['ICDCodeslist']=this.caseInfoDetails['OrderDetails'].Order.ICDCodes.split(',')
      }
      if(this.caseInfoDetails['SubscriberDetails']!== undefined?this.caseInfoDetails['SubscriberDetails'].Subscriber:false){
        if(Array.isArray(this.caseInfoDetails['SubscriberDetails'].Subscriber)){
          this.caseInfoDetails['primarySubscriber']=this.caseInfoDetails['SubscriberDetails'].Subscriber.find(va => va.ResponsibilityCode =="P")
          this.caseInfoDetails['secondarySubscriber']=this.caseInfoDetails['SubscriberDetails'].Subscriber.find(va => va.ResponsibilityCode =="S")
          this.caseInfoDetails['tertairySubscriber']=this.caseInfoDetails['SubscriberDetails'].Subscriber.find(va => va.ResponsibilityCode =="T")
        }else{
          if(this.caseInfoDetails['SubscriberDetails'].Subscriber.ResponsibilityCode =="P"){
            this.caseInfoDetails['primarySubscriber'] = this.caseInfoDetails['SubscriberDetails'].Subscriber
          }
          if(this.caseInfoDetails['SubscriberDetails'].Subscriber.ResponsibilityCode =="S"){
            this.caseInfoDetails['secondarySubscriber'] = this.caseInfoDetails['SubscriberDetails'].Subscriber
          }
          if(this.caseInfoDetails['SubscriberDetails'].Subscriber.ResponsibilityCode =="T"){
            this.caseInfoDetails['tertairySubscriber'] = this.caseInfoDetails['SubscriberDetails'].Subscriber
          }
        }
      }
    }
    this.service.auditsave("View", "", "Viewed case info", "case", this.caseInfoDetails['CaseGUID'], "Caseinfo tab ,deployment key :-"+this.caseInfoData.DeploymentKey);
  }

  moreInfo(modalrefid,tabindex,infoType) {

    const modalRef = this.modalService
      .open(modalrefid, {
        windowClass: "viewstagescase360",
        backdrop: "static",
        keyboard: false,
      });
    this.currentModalRefs.push(modalRef);
    
    modalRef.result.then((result) => {
      this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
    }, (reason) => {
      this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
    });
    
    // Add data attribute to identify the modal and backdrop
    this.modalTabVisibility.tagOwned('data-case360-modal', 'viewstagescase360');
    
    this.modalWasOpen = true;
    this.selectedIndexTab = tabindex;
    infoType!=''?this.service.auditsave("View", "", "Viewed "+infoType, "case", this.caseInfoDetails['CaseGUID'], "Caseinfo tab ,deployment key :-"+this.caseInfoData.DeploymentKey):'';
}
closemoreinfopopup(c) {
  c("close modal");
}

viewCaseFile(report){
  let location
if(this.caseInfoDetails['ServiceProvider'].length>0){
  location= this.caseInfoDetails['ServiceProvider'].find(value => value.Location.AccountType=="Laboratory")
  if(location !== undefined){
    location = location.Location
  }
}else{
  location= this.caseInfoDetails['ServiceProvider'].Location
}
  let obj=
    {
      "RequestID": report.File.PresentationData,
      "Type": report.File.Category,
      "RequestGUID": report.File.FileGUID,
      "LabOrgGUID":location.OrganizationGUID,
      "CaseGUID": this.caseInfoDetails['CaseGUID'],
      "DeploymentsKey":this.caseInfoData['DeploymentKey']
    }
    this.ngxUiLoaderService.start()
    this.service.viewCases360DXReport(obj).subscribe(data=>{
      this.ngxUiLoaderService.stop()
      if( data.StatusMessage !== null &&data.StatusMessage.toLowerCase() !== "failed"){
        if(data['FileContent'] !== null){
          'data:application/pdf;base64,'+data['FileContent'];
          let namemodal={
            name:report.ReportName,
            fullfile:data['FileContent']
          }
          this.service.auditsave("View", "", "Viewed dx report :-"+report.ReportName, "case", this.caseInfoDetails['CaseGUID'], "Caseinfo tab ,deployment key :-"+this.caseInfoData.DeploymentKey);
          const modalRef = this.modalService.open(FileViewExplorerComponent
            , {
            windowClass: "myCustomModalViewfilecase360",
            backdrop: "static",
            keyboard: false
          });
          modalRef.componentInstance.fileData =namemodal ;
          this.currentModalRefs.push(modalRef);
          
          modalRef.result.then(() => {
            this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
          }, (reason) => {
            this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
          });
          
          // Add data attribute to identify the modal and backdrop
          this.modalTabVisibility.tagOwned('data-case360-modal', 'myCustomModalViewfilecase360');
          
          this.modalWasOpen = true;
              }else{
                this.ngxUiLoaderService.stop();
                this.toastr.warning('Data not Found', "Alert", {
                  positionClass: "toast-bottom-right",
                  timeOut: 4000,
                });
              }
      }else{
        this.ngxUiLoaderService.stop();
        this.service.copyableToastError(data.FileContent,'Failed');
      }

    },error=>{
      this.ngxUiLoaderService.stop()
    })
}
  
  ngOnDestroy() {
    // Close all open modals when component is destroyed
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      this.currentModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Modal might already be closed, ignore error
          }
        }
      });
      this.currentModalRefs = [];
    }
    
    this.destroy$.next();
    this.destroy$.complete();
    if (this.tabChangeSubscription) {
      this.tabChangeSubscription.unsubscribe();
    }
  }
  
  hideModals() {
  const result = this.modalTabVisibility.hideOwned('data-case360-modal', {
    hasOpenRefs: this.currentModalRefs?.length > 0,
    windowClasses: ["myCustomModalClasscase360audit","myCustomModalViewfilecase360","myCustomModalClasscase360hl7","myCustomModalClassFTPcase360","myCustomModalClasscase360","Mode_Bootcase360","viewstagescasemsg360","viewstagescase360","messageiotcase360","PopupScreencase360"],
    nestedOwnerAttrs: ['data-case360-nested-modal'],
  });
  this.modalWasOpen = result.modalWasOpen;
}

showModals() {
  this.modalTabVisibility.showOwned('data-case360-modal', {
    modalWasOpen: this.modalWasOpen,
    hasOpenRefs: this.currentModalRefs?.length > 0,
    windowClasses: ["myCustomModalClasscase360audit","myCustomModalViewfilecase360","myCustomModalClasscase360hl7","myCustomModalClassFTPcase360","myCustomModalClasscase360","Mode_Bootcase360","viewstagescasemsg360","viewstagescase360","messageiotcase360","PopupScreencase360"],
    nestedOwnerAttrs: ['data-case360-nested-modal'],
  });
}

  /**
   * Extracts only the date part from a datetime string
   * @param dateTimeString - Date string in format "MM/DD/YYYY HH:mm:ss" or similar
   * @returns Date part only (e.g., "12/15/2025")
   */
  getDateOnly(dateTimeString: string): string {
    if (!dateTimeString) {
      return '';
    }
    // Split by space and take the first part (date)
    return dateTimeString.split(' ')[0];
  }
}
